import $ from 'jquery';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '#abcParalax',
			dom: {
				top: '.js-abc-paralax-top',
				bottom: '.js-abc-paralax-bottom'
			},
			delta: 400
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.prefixed = new Prefixed();
		return this;
	}

	getDom() {
		const self = this;
		self.$top = self.$el.find(self.options.dom.top);
		self.$bottom = self.$el.find(self.options.dom.bottom);
		return self;
	}

	onScroll() {
		const scroll = window.pageYOffset;
		const top = this.$el.offset().top;
		const height = this.$el.height();
		const wHeight = this.$window.height();
		const max = height - wHeight;
		const pos = scroll - top;

		// if (pos < 0) {
		// 	pos = 0;
		// }
		// if (pos > max) {
		// 	pos = max;
		// }

		const delta = (this.options.delta - this.options.delta / max * pos) * -1;
		this.$top.css(this.prefixed.css.transform, 'translateY(' + Math.ceil(delta - pos * 0.2) + 'px) translateZ(0)');
		this.$bottom.css(this.prefixed.css.transform, 'translateY(' + Math.ceil(delta) + 'px) translateZ(0)');
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.$window.on('scroll resize', self.onScroll.bind(self));

			self.onScroll();
			setTimeout(function () {
				self.onScroll();
			}, 250);
			setTimeout(function () {
				self.onScroll();
			}, 750);
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/abc-paralax/abc-paralax.js